import GaugeChart from "react-gauge-chart";
import ProgressBar from "../../components/barrProgress";
import { DadosMotoBombaStyled } from "../../styles/motoBomba";
import { TbAlertTriangle } from "react-icons/tb";
import { useEffect, useState } from "react";

export const DadosMotoomba = ({ Motor }) => {
  const [percentual, setPercentual] = useState(Motor.temperaturaMotor / 180);

  useEffect(() => {
    // Atualiza o percentual apenas quando a temperaturaMotor for alterada
    setPercentual(Motor.temperaturaMotor / 180);
  }, [Motor.temperaturaMotor]);
  return (
    <DadosMotoBombaStyled>
      <h3>Dados</h3>
      <ul>
        <li className="dados">
          <p>Status do Motor</p>
          <span>{Motor.statusMotor ? "Ligado" : "Desligado"}</span>
        </li>
        <li className="dados">
          <p>Tensão da Bateria</p>
          <span>{Motor.tensaoBateria}V</span>
          {Motor.tensaoBateria === 0 && (
            <div className="alertaBateria">
              {/* <LuAlertTriangle className="icon" /> */}
              <TbAlertTriangle className="icon"/>
              <p>verifique a bateria</p>
            </div>
          )}
        </li>
        <li className="dados">
          <p>Tensão do Alternador</p>
          <span>{Motor.tensaoAlternador}V</span>
        </li>
      </ul>
      <ul>
        <li className="dadosBarra">
          <p>RPM</p>
          <ProgressBar min={0} max={5000} value={Motor.rotacaoMotor} />
        </li>
        <li className="dadosBarra">
          <p>Pressão da Água </p>
          <ProgressBar
            min={0}
            max={3}
            value={Motor.pressaoBombaAgua}
            tipo={"Bar"}
          />
        </li>
        <li className="dadosBarra">
          <p>Nivel do Disel</p>
          <ProgressBar
            min={0}
            max={100}
            value={Motor.nivelCombustivel}
            tipo={"L"}
          />
        </li>
        <li className="dadosBarra">
          <p>Pressao do Disel</p>
          <ProgressBar
            min={0}
            max={2000}
            value={Motor.pressaoDiesel}
            tipo={"Bar"}
          />
        </li>
        <li className="dadosBarra">
          <p>Temperatura do Motor</p>
          <div className="conteinerTemperatura">
            <GaugeChart
              id="gauge-chart1"
              nrOfLevels={20}
              percent={percentual}
              colors={["rgba(85, 85, 85, 1)", "rgba(138, 74, 74, 1)"]}
              arcWidth={0.3}
              style={{ width: "100%" }}
              hideText={true}
            />
          </div>
          <p>{Motor.temperaturaMotor}C</p>
        </li>
      </ul>
    </DadosMotoBombaStyled>
  );
};
